import $ from 'jquery';
import debounce from './utils/debounce';

class HeaderShare {
    constructor () {
        this.$document = $(document);
        this.$window = $(window);
        this.speed = 500;

        // Social button
        this.$socialButton = $('.js-header-social-button');
        this.$socialButtonText = $('.js-header-social-button-text');
        this.$socialLinks = $('.js-header-social');

        // -------

        // Search Events
        this.$socialButton.on('click', $.proxy(this.toggleSocial, this));

        this.$document.keyup((e) => {
            // Escape Key
            if (e.keyCode === 27) {
                if (this.$socialLinks.hasClass('is-visible')) {
                    this.closeSocial();
                }
            }
        });

        this.$window.on('resize', debounce(() => {
            this.closeSocial();
        }, 300));

    }

    closeSocial () {
        this.$socialButton.removeClass('is-clicked');
        this.$socialLinks.removeClass('is-visible');
        this.$socialButtonText.text('Open social media links dialog');
    }

    toggleSocial (e) {
        const $elem = $(e.currentTarget);
        $elem.toggleClass('is-clicked');

        this.$socialLinks.toggleClass('is-visible');

        if ($elem.hasClass('is-clicked')) {
            this.$socialButtonText.text('Close social media links dialog');
        } else {
            this.$socialButtonText.text('Open social media links dialog');
        }
    }
}

export default HeaderShare;
